module.exports = __webpack_public_path__ + "img/comment.7b237298.svg";